import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getDistributionListsForOrder = async (orderApplicationId) => {
	const { data } = await axios.get(`${API}/app/planning/order_application/${orderApplicationId}/distribution-lists`);
	return data;
};
